export default {
    // 消息中间件信息查询接口
    listMenuInfo(params, response) {
        window.vue.$apiAxios.postRequestBody('/menuManager/listMenuInfo', params, response);
    },
    // 消息中间件删除接口
    deleteMenuInfo(params, response) {
        window.vue.$apiAxios.delete('/menuManager/deleteMenuInfo', params, response);
    },
    // 消息添加接口
    insertMenuInfo(params, response) {
        window.vue.$apiAxios.postRequestBody('/menuManager/insertMenuInfo', params, response);
    },
    // 消息更新接口
    updateMenuInfo(params, response) {
        window.vue.$apiAxios.postRequestBody('/menuManager/updateMenuInfo', params, response);
    }
};
